export const volumes = [
  {
    numeral: "I",
    title: "Self-Ligating Orthodontics Fundamentals™",
    tagline: "Understand the Systems Before Planning Around Them.",
    intro: [
      "Self-ligating brackets are not all the same.",
      "This volume introduces the fundamental concepts needed to understand their design, mechanical behavior, and clinical applications.",
    ],
    topics: [
      "Active versus passive self-ligating mechanisms",
      "Bracket design and slot characteristics",
      "Friction, binding, and resistance to sliding",
      "Bracket–archwire interactions",
      "Mechanical advantages and limitations",
      "Evidence-based comparisons with conventional brackets",
      "Common misconceptions about self-ligating systems",
    ],
    objective: "Understand what these appliances do mechanically, what the evidence supports, and what should not be assumed.",
  },
  {
    numeral: "II",
    title: "Clinical Diagnosis & Case Selection Blueprint™",
    tagline: "Understand the Patient Before Choosing the Appliance.",
    intro: [
      "Successful planning begins with an appropriate clinical assessment, not with bracket selection.",
      "This volume organizes the diagnostic considerations relevant to orthodontic treatment planning, with worksheets that help distinguish diagnostic findings from treatment objectives.",
    ],
    topics: [
      "Comprehensive orthodontic assessment",
      "Skeletal and dental relationships",
      "Facial and soft-tissue considerations",
      "Periodontal and biological limitations",
      "Crowding and spacing evaluation",
      "Transverse and vertical discrepancies",
      "Treatment objectives and clinical priorities",
      "Case selection considerations",
    ],
    objective: "Develop a structured understanding of patient assessment and the factors that influence appliance selection.",
  },
  {
    numeral: "III",
    title: "Archwire Selection & Biomechanics Roadmap™",
    tagline: "Understand the Mechanics Behind Each Treatment Phase.",
    intro: [
      "Archwire selection involves more than following a manufacturer's sequence.",
      "It requires understanding material properties, force systems, movement objectives, and clinical limitations. Includes visual reference tables for learning and comparison.",
    ],
    topics: [
      "Nickel-titanium and stainless-steel archwire properties",
      "Archwire dimensions and mechanical characteristics",
      "Force delivery and load-deflection behavior",
      "Bracket–archwire engagement",
      "Alignment and leveling biomechanics",
      "Torque expression considerations",
      "Anchorage interactions",
      "Biomechanical limitations and common misconceptions",
    ],
    objective: "Understand the principles that inform archwire-related decisions without relying on a universal sequence for every patient.",
  },
  {
    numeral: "IV",
    title: "Treatment Sequencing & Anchorage Control Blueprint™",
    tagline: "Connect Individual Movements Into an Organized Treatment Strategy.",
    intro: [
      "Orthodontic treatment is not simply a collection of desired tooth movements. The order of clinical objectives matters.",
      "You'll learn how to organize the relationships between objectives, movements, constraints, and monitoring.",
    ],
    topics: [
      "Defining treatment phases",
      "Alignment and leveling considerations",
      "Space management principles",
      "Anchorage planning",
      "Movement dependencies",
      "Biomechanical interactions",
      "Treatment sequencing considerations",
      "Reassessment checkpoints",
    ],
    objective: "Understand how clinical decisions fit together across the treatment process.",
  },
  {
    numeral: "V",
    title: "Clinical Challenges & Troubleshooting Atlas™",
    tagline: "Recognize the Factors That May Require Reassessment.",
    intro: [
      "Not every treatment progresses exactly as anticipated. Understanding potential complications and limitations is an essential part of orthodontic education.",
      "This volume uses educational scenarios and structured review questions.",
    ],
    topics: [
      "Unexpected movement patterns",
      "Anchorage-related challenges",
      "Alignment and leveling difficulties",
      "Bracket–archwire interaction issues",
      "Periodontal considerations",
      "Treatment progress discrepancies",
      "Common planning oversights",
      "Situations requiring additional assessment or specialist consultation",
    ],
    objective: "Develop a systematic approach to recognizing concerns and understanding when clinical reassessment may be necessary.",
  },
  {
    numeral: "VI",
    title: "Finishing, Retention & Complete Case Review™",
    tagline: "Understand What Comes After the Initial Treatment Phases.",
    intro: [
      "A complete orthodontic educational framework must address treatment objectives beyond initial alignment.",
      "You'll also learn how to organize a final case summary connecting initial findings with treatment objectives and outcomes.",
    ],
    topics: [
      "Finishing objectives",
      "Occlusal assessment principles",
      "Tooth position and root alignment considerations",
      "Functional evaluation",
      "Retention planning principles",
      "Stability and relapse considerations",
      "Documentation and follow-up",
      "Comprehensive case review",
    ],
    objective: "Understand the complete treatment pathway, including its final assessment and follow-up considerations.",
  },
];

export const resources = [
  { icon: "checklist", title: "Clinical Assessment Checklists", text: "Organize diagnostic findings, objectives, and considerations for further evaluation." },
  { icon: "diagram", title: "Biomechanics Decision Diagrams", text: "Visualize the relationships between force systems, bracket mechanics, and tooth movement." },
  { icon: "table", title: "Archwire Reference Tables", text: "Compare material properties, dimensions, and relevant biomechanical considerations." },
  { icon: "sequence", title: "Treatment Sequencing Worksheets", text: "Organize proposed treatment phases and the dependencies between clinical objectives." },
  { icon: "review", title: "Clinical Review Templates", text: "Document observations, questions, and areas requiring further assessment." },
] as const;
